import api from "./api";

export const nmmcCardService = {
  // Get all NMMC cards (admin)
  getAllNmmcCards: async (card_type = null, is_active = null) => {
    const params = {};
    if (card_type) params.card_type = card_type;
    if (is_active !== null) params.is_active = is_active;
    const response = await api.get(`/nmmccard/getallnmmccards`, { params });
    return response.data?.data || response.data || [];
  },

  // Get active NMMC cards (public)
  getActiveNmmcCards: async (card_type = null) => {
    const params = {};
    if (card_type) params.card_type = card_type;
    const response = await api.get(`/nmmccard/getactivenmmccards`, { params });
    return response.data?.data || response.data || [];
  },

  // Get NMMC card by ID
  getNmmcCardById: async (id) => {
    const response = await api.get(`/nmmccard/getnmmccard/${id}`);
    return response.data?.data || response.data;
  },

  // Add new NMMC card
  addNmmcCard: async (formData) => {
    const response = await api.post(`/nmmccard/addnmmccard`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Update NMMC card
  updateNmmcCard: async (id, formData) => {
    const response = await api.put(`/nmmccard/updatenmmccard/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Delete NMMC card
  deleteNmmcCard: async (id) => {
    const response = await api.delete(`/nmmccard/deletenmmccard/${id}`);
    return response.data;
  },
};
